var _path, _rect, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorHinged = function SvgDoorHinged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.67,
    d: "M4.29 26.52H28.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.71,
    height: 20.38,
    x: 7.96,
    y: 6.14,
    fill: "red",
    stroke: "currentColor",
    strokeWidth: 2.67,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M7.93 7.8a2 2 0 0 1 1.26-1.85l5.4-2.13a2 2 0 0 1 2.73 1.87v20.88a2 2 0 0 1-2.56 1.92l-5.4-1.59a2 2 0 0 1-1.43-1.92V7.81Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.91,
    cy: 15.91,
    r: 1.3
  })));
};
export default SvgDoorHinged;